import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IThemeState, themeTypes } from './types';
import * as themeActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IThemeState = {
  primary: '#22767c',
  secondary: '#e3923b',
  backgroundUrl: '',
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IThemeState, payload: UnsafeReturnType<T>): IThemeState;
}

const setTheme: IActionHandler<typeof themeActions['setTheme']> = (state, { payload }) => ({
  ...state,
  ...payload,
});

const resetTheme: IActionHandler<typeof themeActions['resetTheme']> = state => ({
  ...state,
  ...INITIAL_STATE,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [themeTypes.SET_THEME]: setTheme,
  [themeTypes.RESET_THEME]: resetTheme,
};

const themeReducer = createReducer<IThemeState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { themeReducer, themeTypes, themeActions };
